module.exports = "/images/model_48950c.png";